import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Calendar from 'react-calendar';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function CalenderModal({ todayDate, calenderOpen, setCalenderOpen, setSelectDate }) {
  const handleClose = () => setCalenderOpen(false);

  const formattedDate = new Date(todayDate);

  return (
    <div>
      <Modal
        open={calenderOpen}
        onClose={handleClose}
        aria-labelledby="calender-modal-title"
        aria-describedby="calender-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Select a date
          </Typography>

          {calenderOpen ? <Calendar onChange={setSelectDate} value={formattedDate} /> : null}
        </Box>
      </Modal>
    </div>
  );
}
